<template>
  <div v-if="category !== null">
    <b-card>
      <b-tabs>
        <b-tab active>
          <template #title>
            <feather-icon icon="ListIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">ویرایش دسته بندی بلاگ</span>
          </template>

          <b-form>
            <b-row>
              <b-col cols="12" class="mb-1">
                <h3>نام دسته بندی</h3>
              </b-col>

              <!-- Field: name -->
              <b-col cols="12" md="4">
                <b-form-group label-for="name">
                  <b-form-input id="name" v-model="category.name" />
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>

          <!-- Action Buttons -->
          <b-button
            variant="primary"
            class="mt-1 mb-sm-0 mr-0 mr-sm-1"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            @click="updateCategory"
          >
            ذخیره تغییرات
          </b-button>
        </b-tab>
        <b-tab>
          <template #title>
            <feather-icon icon="SearchIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">ویرایش جزئیات سئو</span>
          </template>
          <b-form class="mt-2">
            <b-row>
              <b-col md="6">
                <b-form-group
                  label="سئو تایتل (50 تا 60 کاراکتر)"
                  label-for="blog-edit-title"
                  class="mb-2"
                >
                  <b-form-input
                    id="blog-edit-title"
                    v-model="category.seoTitle"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="سئو URL (تا 75 کاراکتر)"
                  label-for="blog-edit-title"
                  class="mb-2"
                >
                  <b-form-input
                    id="blog-edit-title"
                    v-model="category.seourl"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group
                  label="سئو Description (155 تا 160 کاراکتر)"
                  label-for="blog-edit-title"
                  class="mb-2"
                >
                  <b-form-textarea
                    id="blog-edit-title"
                    v-model="category.seoDescription"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <div class="serp-box">
                  <h3>
                    <a href="#" target="_blank"
                      >{{ category.seoTitle }} | فرادیدار</a
                    >
                  </h3>

                  <cite dir="ltr">
                    www.faradidar.com/blogs/{{ category.blogCategoryId }}/{{
                      category.seourl
                    }}
                  </cite>

                  <p v-html="category.seoDescription"></p>
                </div>
              </b-col>
            </b-row>
          </b-form>
          <b-button
            variant="primary"
            class="mt-1 mb-sm-0 mr-0 mr-sm-1"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            @click="updateBlogCategorySeo"
          >
            ذخیره تغییرات
          </b-button>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BTabs,
  BTab,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BFormTextarea,
  BPagination,
  BFormGroup,
  BForm,
  BModal,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import BlogCategoryUpdateRequest from "@/libs/Api/Blog/BlogCategoryUpdateRequest";
import BlogCategoryGetRequest from "@/libs/Api/Blog/BlogCategoryGetRequest";
import BlogCategorySeoUpdateRequest from "@/libs/Api/Blog/BlogCategorySeoUpdateRequest";

export default {
  name: "categories-edit",
  title: "ویرایش دسته بندی بلاگ - پنل ادمین فرادیدار",
  data() {
    return {
      category: null,
      categoryProperties: null,
      categoryId: this.$route.params.id,
      addNewCategoryProperty: false,
      myTableColumns: [
        { key: "categoryPropertyId", label: "شناسه" },
        { key: "name", label: "نام" },
        { key: "delete", label: "حذف" },
        { key: "edit", label: "ویرایش" },
      ],
      defaultCreateCategoryPropertyData: {
        isDeleted: false,
        categoryPropertyId: 0,
        categoryId: this.$route.params.id,
        name: "",
      },
      updateCategoryPropertyData: null,
    };
  },
  async created() {
    await this.getCategory();
  },
  methods: {
    async updateBlogCategorySeo() {
      let _this = this;

      let blogCategoryUpdateRequest = new BlogCategoryUpdateRequest(_this);
      blogCategoryUpdateRequest.setParams(_this.category);
      await blogCategoryUpdateRequest.fetch(
        function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `عملیات موفق`,
              icon: "CheckIcon",
              variant: "success",
              text: `تغییرات اعمال شد.`,
            },
          });
          _this.getCategory();
        },
        function (error) {
          console.log(error);
        }
      );
    },
    async getCategory() {
      let _this = this;

      let blogCategoryGetRequest = new BlogCategoryGetRequest(_this);
      blogCategoryGetRequest.setId(_this.categoryId);
      await blogCategoryGetRequest.fetch(
        function (content) {
          _this.category = content;
        },
        function (error) {
          console.log(error);
        }
      );
    },
    async updateCategory() {
      let _this = this;

      let blogCategorySeoUpdateRequest = new BlogCategorySeoUpdateRequest(
        _this
      );
      blogCategorySeoUpdateRequest.setParams(_this.category);
      await blogCategorySeoUpdateRequest.fetch(
        function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `عملیات موفق`,
              icon: "CheckIcon",
              variant: "success",
              text: `تغییرات اعمال شد.`,
            },
          });
          _this.getCategory();
        },
        function (error) {
          console.log(error);
        }
      );
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BTabs,
    BTab,
    BFormGroup,
    BFormTextarea,
    BBadge,
    BForm,
    BDropdown,
    BDropdownItem,
    BPagination,
    BModal,
  },
};
</script>

<style scoped>
.serp-box {
  font-family: Arial, sans-serif;
  font-weight: 400;
  line-height: normal;
  margin: 0 0 10px 0;
  color: #222;
  border-radius: 2px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.serp-box h3 {
  font-family: Arial, sans-serif;
  font-size: 18px;
  font-weight: normal;

  display: block;
  overflow: hidden;

  margin: 0;
  padding: 11px 16px 0 16px;

  text-align: left;
  white-space: nowrap;
  text-transform: none;
  text-overflow: ellipsis;

  -moz-text-overflow: ellipsis;
}

.serp-box h3 a {
  white-space: nowrap;
  text-decoration: none;

  color: #1a0dab;
}

.serp-box cite {
  font-size: 14px;
  font-style: normal;
  line-height: 16px;

  display: block;

  padding: 0 16px 0 16px;

  color: #006621;
}

.serp-box p {
  font-size: 13px;
  line-height: 1.4;

  margin: 1px 0 0 0;
  padding: 0 16px 11px 16px;

  cursor: text;
  word-wrap: break-word;
}

.serp-box p a {
  text-decoration: none;
  pointer-events: none;

  color: #545454;
}

.serp-box p em {
  font-family: Arial, sans-serif;
  font-weight: bold;
  font-style: normal;

  color: #6a6a6a;
}

@media (max-width: 760px) {
  .serp-box cite {
    padding-bottom: 11px;
  }

  .serp-box p {
    margin: 0;
    padding-top: 11px;

    border-top: 1px solid #ebebeb;
  }

  .serp-box p a {
    pointer-events: auto;
  }
}
</style>
